import { combineReducers } from 'redux';
import {
  getMainTabID,
  getJourneyTab,
  getSelectedLevelKey,
  getSelectedRoleID,
  getDealershipID,
  getDealershipList,
  getAllDepartments,
  getDealershipDetails,
  getDepartmentRole,
  getDepartment,
  setDepartmentEmpCnt,
  showProgress,
  getJourneyList,
  getPlanList,
  getCollectionList,
  getPlanDetails,
  getCategoryList,
  getEmployeeList,
  getJourneyID,
  getJourneyDetails,
  getSelectedLevelID,
  getLevelDetails,
  getGuideID,
  getGuideDetails,
  getCapstoneDetails,
  getCapstoneID,
  getCapstoneActivityDetails,
  getCapstoneActivityList,
  getCapstoneActivityID,
  getGuideTagList,
  getAssignedJourneys,
  getCheckedAssignedJourneys,
  getCheckedAssignedInstr,
  getMandatoryJourneys,
  getCheckedJourneys,
  getCheckedInstr,
  getTagList,
  getPubDates,
  getRoleList,
  getDoses,
  getSelectedPubDate,
  getDoseDetails,
  getInstructorList,
  getGuideInstructorList,
  getSelectedDeptRoles,
  getSelectedDealershipFilters,
  getDepartmentRoleList,
  getPlanAssignedJourneys,
  getTempChecksDept,
  getTempChecksRoles,
  getAllBadges,
  getBadgeTypeList,
  getSelectedBadgeType,
  getAuthClientList,
  getSelectedAuthClientID,
  getAuthClientDetails,
  getPlanAuth,
  getCollection,
  getAddCollectionFilters,
  getChildrenDealerships,
  getDealershipMenu,
  setDevAccess,
  showDevPanel,
  getDEVTabId,
  getDealershipAssignedJourneys,
  categoryData,
  leaderboardData,
  contestData,
  adminUsersData,
  networkPartnerData,
  rnpData,
  inappData,
  customGroupsData,
  getCustomGroupsForDealership,
  rulesData,
  getRulesForDealership,
  getTagsForDealership,
  getDealershipDepartments,
  getCustomDepartment,
  getTopicOfTheMonth,
  getLeaderboard,
  pxDashboardData,
  rockedCurriculumData,
  rockedFuelData,
  topicsData,
  certificateData,
  aiRoleplayData,
  getQuizSeries,
  getQuiz,
  getQuizSeriesList,
} from './DealershipReducer';

const reducers = combineReducers({
  getJourneyID,
  getCapstoneID,
  getSelectedLevelID,
  getSelectedRoleID,
  getCapstoneActivityID,
  getSelectedLevelKey,
  getGuideID,
  getAllDepartments,
  getDepartmentRole,
  getSelectedDeptRoles,
  getLevelDetails,
  getGuideDetails,
  getCapstoneDetails,
  getCapstoneActivityDetails,
  getCapstoneActivityList,
  GetJourneyList: getJourneyList,
  GetPlanList: getPlanList,
  GetCollectionList: getCollectionList,
  GetEmployeeList: getEmployeeList,
  JourneyDetails: getJourneyDetails,
  getPlanDetails,
  getMainTabID,
  getDealershipID,
  GetDealershipList: getDealershipList,
  DealershipDetails: getDealershipDetails,
  getDepartment,
  setDepartmentEmpCnt,
  getAssignedJourneys,
  getSelectedDealershipFilters,
  getTagList,
  getCategoryList,
  getRoleList,
  getGuideTagList,
  getCheckedAssignedJourneys,
  getCheckedAssignedInstr,
  getMandatoryJourneys,
  getCheckedJourneys,
  getCheckedInstr,
  showProgress,
  getPubDates,
  getDoses,
  getSelectedPubDate,
  getDoseDetails,
  getInstructorList,
  getGuideInstructorList,
  getJourneyTab,
  getDepartmentRoleList,
  getPlanAssignedJourneys,
  getTempChecksDept,
  getTempChecksRoles,
  getAllBadges,
  getBadgeTypeList,
  getAuthClientList,
  getSelectedBadgeType,
  getSelectedAuthClientID,
  getAuthClientDetails,
  getPlanAuth,
  getCollection,
  getAddCollectionFilters,
  getChildrenDealerships,
  getDealershipMenu,
  setDevAccess,
  showDevPanel,
  getDEVTabId,
  getDealershipAssignedJourneys,
  categoryData,
  leaderboardData,
  contestData,
  adminUsersData,
  networkPartnerData,
  rnpData,
  inappData,
  customGroupsData,
  getCustomGroupsForDealership,
  rulesData,
  getRulesForDealership,
  getTagsForDealership,
  getDealershipDepartments,
  getCustomDepartment,
  getTopicOfTheMonth,
  getLeaderboard,
  pxDashboardData,
  rockedCurriculumData,
  rockedFuelData,
  topicsData,
  certificateData,
  aiRoleplayData,
  getQuizSeries,
  getQuiz,
  getQuizSeriesList,
});

export default reducers;
